export default __webpack_public_path__ + "static/5-5425310c66ecad31b8e391aa85c80c27.jpeg";